var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('register-form',{staticStyle:{"width":"90%","max-width":"400px","margin":"auto","margin-top":"2vh","margin-bottom":"2vh"}})}
var staticRenderFns = []

export { render, staticRenderFns }